import React from "react";
import PropTypes from "prop-types";
import { has } from 'lodash';

const SurveyCode = ({ question = {}, store = {} }) => {
    if (has(question, "showSurveyCode") && question.showSurveyCode) {
        return (
            <div id="surveyCode" className="w3-panel w3-large w3-center w3-opacity">Survey Code:<br/>{store.getState().surveyCode}</div>
        );
    }

    return null;
};

SurveyCode.propTypes = {
    question: PropTypes.object
};

SurveyCode.contextTypes = {
    store: PropTypes.object
};

export default SurveyCode;
